"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartView = exports.chartColors = void 0;
const chart_js_1 = __importDefault(require("chart.js"));
const mithril_1 = __importDefault(require("mithril"));
exports.chartColors = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)'
};
const ChartView = function (chartOrCallBack) {
    let instance;
    let chart;
    let chartAny = chartOrCallBack;
    if (chartAny.call) {
        chart = chartOrCallBack.call(window);
    }
    else {
        chart = chartOrCallBack;
    }
    let opt;
    if (opt = chart.options.options) {
        opt.responsive = true;
    }
    return {
        oncreate(node) {
            const context = node.dom.querySelector("canvas").getContext('2d');
            instance = new chart_js_1.default(context, chart.options);
            chart.getData().then(() => {
                status = 'loaded';
                instance.update();
            });
        },
        update() {
            instance.update();
        },
        view() {
            return (0, mithril_1.default)(".card", (0, mithril_1.default)(".card-content", (0, mithril_1.default)("canvas")));
        },
        chart: chart,
    };
};
exports.ChartView = ChartView;
